import { useDispatch } from 'react-redux'
import { ModalBody } from 'reactstrap'
import { checkPDFSettings } from 'store/Course/actions'
import CustomModal from 'views/pages/CustomModal'
import DocumentViewer from 'views/pages/DocumentViewer'

const ViewLibraryPDF = (props) => {
  const urlObj = new URL(location.href) //eslint-disable-line
  const dispatch = useDispatch()
  return (
    <CustomModal
      backPath={`/library`}
      title={'View PDF'}
      size='xl'
      fullHeight
    >
      <ModalBody className='p-0' style={{ position: 'relative' }}>
        <div
          style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}
        >
          <DocumentViewer
            url={urlObj.searchParams.get('file')}
            contentType={'application/pdf'}
            checkPDFSettings={() => dispatch(checkPDFSettings())}
          />
        </div>
      </ModalBody>
    </CustomModal>
  )
}

export default ViewLibraryPDF
